// extracted by mini-css-extract-plugin
export default {"roles":"TransactionParties_roles__awZNc","rounded":"TransactionParties_rounded__ljzkJ"};